import { render, staticRenderFns } from "./ThirdPartyCheckBoxDialog.vue?vue&type=template&id=22979507"
import script from "./ThirdPartyCheckBoxDialog.vue?vue&type=script&lang=js"
export * from "./ThirdPartyCheckBoxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports